export const MIN_PLAYERS = 5;
export const MAX_PLAYERS = 10;
export const LIBERAL_POLICIES_IN_DECK = 6;
export const FASCIST_POLICIES_IN_DECK = 11;
export const LIBERAL_TRACK_SIZE = 5;
export const FASCIST_TRACK_SIZE = 6;
/** Fascist Policies enacted before the Hitler-as-Chancellor win condition arms. */
export const HITLER_CHANCELLOR_THRESHOLD = 3;
/** Fascist Policies enacted before the Executive branch gains the Veto Power. */
export const VETO_THRESHOLD = 5;
/** Failed elections in a row before the country is thrown into chaos. */
export const CHAOS_THRESHOLD = 3;
/**
 * The skin a table gets before anybody picks one. The real artwork rather than
 * the original one: a group sitting down to this has almost certainly played
 * the physical game, and the cards they know are the ones they should see
 * without having to go looking for a setting. The Minimal skin is still there,
 * and is still what everything falls back to if a manifest fails to load,
 * because it ships no artwork and so cannot fail to render.
 */
export const DEFAULT_SKIN = 'classic';
/**
 * The skin that needs nothing on disk. Its palette is the one baked into the
 * stylesheet's `:root`, so a table lands here whenever there is no artwork to
 * be had - the skins directory is empty, a manifest will not load, or the
 * operator has turned skins off - and still gets a complete, readable board.
 */
export const MINIMAL_SKIN = 'minimal';
/**
 * Role distribution by player count.
 * NOTE: this table is a graphic in the official rules PDF, not text.
 * Verify against the board images before trusting it.
 */
export const ROLE_DISTRIBUTION = {
    5: { liberals: 3, fascists: 1 },
    6: { liberals: 4, fascists: 1 },
    7: { liberals: 4, fascists: 2 },
    8: { liberals: 5, fascists: 2 },
    9: { liberals: 5, fascists: 3 },
    10: { liberals: 6, fascists: 3 },
};
/**
 * Presidential Power granted by each position on the Fascist track (1-indexed
 * position -> index 0..5). The 6th slot ends the game in a Fascist victory.
 *
 * NOTE: also a graphic in the official rules PDF. Verify against the boards.
 */
const FASCIST_TRACK_5_6 = [
    null,
    null,
    'policy_peek',
    'execution',
    'execution',
    null,
];
const FASCIST_TRACK_7_8 = [
    null,
    'investigate',
    'special_election',
    'execution',
    'execution',
    null,
];
const FASCIST_TRACK_9_10 = [
    'investigate',
    'investigate',
    'special_election',
    'execution',
    'execution',
    null,
];
export function fascistTrack(playerCount) {
    if (playerCount <= 6)
        return FASCIST_TRACK_5_6;
    if (playerCount <= 8)
        return FASCIST_TRACK_7_8;
    return FASCIST_TRACK_9_10;
}
/**
 * The power granted by enacting the Nth Fascist Policy (1-indexed).
 * Only fires for a policy enacted by an elected government - a chaos policy
 * grants nothing.
 */
export function powerForFascistPolicy(playerCount, fascistPoliciesEnacted) {
    const track = fascistTrack(playerCount);
    return track[fascistPoliciesEnacted - 1] ?? null;
}
/**
 * In 5-6 player games Hitler knows the Fascists. In 7-10 player games Hitler
 * does not, and must work them out.
 */
export function hitlerKnowsFascists(playerCount) {
    return playerCount <= 6;
}
//# sourceMappingURL=tables.js.map